import { faCheck, faXmark, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box, Tooltip, IconButton, Menu, MenuItem,
  ListItemIcon, ListItemText, Typography
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { dialogListSignIn } from "../../../../functions/dialog/dialogSignIn/confirm/createDialogConfirmActionInDialogSignIn";
import createDialogConfirmActionInDialogSignIn from "../../../../functions/dialog/dialogSignIn/confirm/createDialogConfirmActionInDialogSignIn"; import DialogConferma from "../../../UI/Dialog/DialogConferma";
import { reloadingDataTableUsers } from "../../../../redux/reducers/dataTableUsers-reducer";
import useMobileDetection from "../../../../Hooks/useMobileDetection";
import { useSelector } from "react-redux";

export default function ButtonBoxRichiesteCredenziali({ row: rowInfo }) {
  const { t } = useTranslation();
  const viewState = useSelector((state) => state.viewState);
  const isMobile = useMobileDetection(600);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const [isOpenDialogConfirm, setIsOpenDialogConfirm] = useState(false);
  const [dialog, setDialog] = useState("");
  const [noteValue, setNoteValue] = useState("");

  const objectToDialogConfirm = createDialogConfirmActionInDialogSignIn(
    dialog,
    { IdRichiesta: rowInfo?.idRichiesta, Note: noteValue },
    rowInfo,
    t
  );

  const handleMenuClick = (event) => setMenuAnchorEl(event.currentTarget);
  const handleMenuClose = () => setMenuAnchorEl(null);

  const handleAction = (dialogType) => () => {
    setDialog(dialogType);
    setIsOpenDialogConfirm(true);
    handleMenuClose();
  };
  const actionButtonStyle = {
    border: "1px solid #dcdcdc",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#eae5e591",
    cursor: "pointer",
    minWidth: "78px",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#3e6bb4",
    },
  };

  if (isMobile || viewState) {
    return (
      <>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 0.5 }} >
          <IconButton style={actionButtonStyle}
            size="small"
            onClick={handleAction(dialogListSignIn.approved)}
            sx={{ borderRadius: "8px", gap: 0.5 }}
          >
            <FontAwesomeIcon icon={faCheck} />
            <Typography >{t("approve")}</Typography>
          </IconButton>

          <IconButton style={actionButtonStyle}
            size="small"
            onClick={handleAction(dialogListSignIn.refuse)}
            sx={{ borderRadius: "8px", gap: 0.5 }}
          >
            <FontAwesomeIcon icon={faXmark} />
            <Typography >{t("reject")}</Typography>
          </IconButton>
        </Box>

        <DialogConferma
          isOpenDialog={isOpenDialogConfirm}
          object={objectToDialogConfirm}
          returnTextNote={setNoteValue}
          handleState={setIsOpenDialogConfirm}
          reloadAfterAction={reloadingDataTableUsers()}
        />
      </>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip title={t("actions")}>
          <IconButton
            onClick={handleMenuClick}
            size="small"
            sx={{ width: 40, height: 40, borderRadius: "50%" }}
          >
            <FontAwesomeIcon icon={faEllipsisV} size="lg" />
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <MenuItem onClick={handleAction(dialogListSignIn.approved)}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faCheck} />
          </ListItemIcon>
          <ListItemText>{t("approve")}</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleAction(dialogListSignIn.refuse)}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faXmark} />
          </ListItemIcon>
          <ListItemText>{t("reject")}</ListItemText>
        </MenuItem>
      </Menu>

      <DialogConferma
        isOpenDialog={isOpenDialogConfirm}
        object={objectToDialogConfirm}
        returnTextNote={setNoteValue}
        handleState={setIsOpenDialogConfirm}
        reloadAfterAction={reloadingDataTableUsers()}
      />
    </>
  );
}